import Splide from '@splidejs/splide';

const EL = '.js-products-strip';
const ACTIVE_CLASS = 'is-active';

const elements = document.querySelectorAll(EL);

elements.forEach((element) => {
  new Splide(element, {
    pagination: false,
    perPage: 2,
    arrows: true,
    gap: 72,
    breakpoints: {
      1366: {
        gap: 36,
      },
      1024: {
        destroy: true
      }
    }
  }).mount();
});
